<template>
  <v-container fluid>
        <editor
          :initial="dataItem"
        ></editor>
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "./_components/editor.vue";
export default {
  components: {
    Editor,
  },
  computed: {
    walkinCustomer() {
      let status = false;
      if (this.DefaultCustomer == this.dataItem.CardCode) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    accountsWalkin() {
      let status = false;
      if (
        this.DefaultCustomer == this.dataItem.CardCode &&
        this.AccountsVersion == "Y"
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
  },
  data: () => ({
    dataItem: {},
    DefaultCustomer: null,
    AccountsVersion: null,
    outsourcedData: [],
    salePayments: [],
    docCreate: false,
    copyStatus: false,
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/sales-invoice/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
  },
};
</script>